import { userApi } from "@/services/user.service";
import { combineReducers, configureStore, Reducer } from "@reduxjs/toolkit";
import appSlice from "./features/app.slice";
import authSlice from "./features/auth.slice";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import { encryptTransform } from 'redux-persist-transform-encrypt';
import { ErrorMiddleware } from "@/store/middlewares/error.middleware";
import { authApi } from "@/services/auth.service";
import { SuccessMiddleware } from "./middlewares/success.middleware";
import { permissionApi } from "@/services/permission.service";
import { businessApi } from "@/services/businessunit.service";
import { unitCodeApi } from "@/services/unitcode.service";
import { transactionTypeApi } from "@/services/transactiontype.service";
import { transactionApi } from "@/services/transaction.service";
import { auditLogApi } from "@/services/auditlog.service";
import { companyApi } from "@/services/company.service";
import { rentalApi } from "@/services/rental.service";
import { tenantApi } from "@/services/tenant.service";
import { houseRentalApi } from "@/services/house-rental.service";
import { dashboardApi } from "@/services/dashboard.service";
import { kpiApi } from "@/services/kpi.service";
import { externalApiApi } from "@/services/external-api.service";

const persistConfig = {
  key: "root",
  storage,
  transforms: [
    encryptTransform({
      secretKey: import.meta.env.VITE_PERSIST_KEY,
    }),
  ],
  whitelist: ["auth"],
  // blacklist: [""],
};

const rootReducer = combineReducers({
  app: appSlice,
  auth: authSlice,
  [userApi.reducerPath]: userApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [permissionApi.reducerPath]: permissionApi.reducer,
  [businessApi.reducerPath]: businessApi.reducer,
  [unitCodeApi.reducerPath]: unitCodeApi.reducer,
  [transactionTypeApi.reducerPath]: transactionTypeApi.reducer,
  [transactionApi.reducerPath]: transactionApi.reducer,
  [auditLogApi.reducerPath]: auditLogApi.reducer,
  [companyApi.reducerPath]: companyApi.reducer,
  [rentalApi.reducerPath]: rentalApi.reducer,
  [tenantApi.reducerPath]: tenantApi.reducer,
  [houseRentalApi.reducerPath]: houseRentalApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [kpiApi.reducerPath]: kpiApi.reducer,
  [externalApiApi.reducerPath]: externalApiApi.reducer,
}) as Reducer

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat([userApi.middleware, authApi.middleware, permissionApi.middleware, businessApi.middleware, unitCodeApi.middleware, transactionTypeApi.middleware, transactionApi.middleware, auditLogApi.middleware, companyApi.middleware, rentalApi.middleware, tenantApi.middleware, houseRentalApi.middleware, dashboardApi.middleware, kpiApi.middleware, externalApiApi.middleware])
      .prepend([]),
      // .prepend([ErrorMiddleware, SuccessMiddleware]),
  devTools: import.meta.env.DEV, // Enable Redux DevTools in development
});

export const persistor = persistStore(store);
export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
